import React, {useRef, useEffect, useContext} from "react";

import {BackHandler}  from 'react-native';

import {useNavigation} from '@react-navigation/native'

import * as util from '../util/util'

import {novoUsuario} from '../ws/ws_usuarios'

import { ViewDegradeVertical} from '../componentes/ViewDegradeVertical';

import FormularioUsuario from '../componentes/FormularioUsuario'

import {USER_TIPO_PF, TELA_LOGIN, TELA_PRINCIPAL} from '../util/constantes'

import Bloco from '../componentes/Bloco'

import contexto from '../util/contexto'


export default function TelaNovoUsuario(){

	const {setValorContexto} = useContext(contexto);

    const navegacao = new useNavigation();

	const formularioUsuarioRef  = useRef(null)


	const voltar = () => {
			
		util.print("voltando");
		
		navegacao.replace(TELA_LOGIN)
		
		return true;
	};


	useEffect(() => {

		util.print("TelaNovoUsuario");

		BackHandler.addEventListener('hardwareBackPress', voltar);

		formularioUsuarioRef.current.setDados(USER_TIPO_PF, null, null, null, null, null, null, null);

		return () => {
		  BackHandler.removeEventListener('hardwareBackPress', voltar);
		};
	}, []);
   
   
	async function salvar(dados){
		
		dados['token_firebase'] = await util.getToken();
		
         let usuario  = await novoUsuario(dados)

        if(usuario == null || usuario.id ==null){
             
			formularioUsuarioRef.current.salvarErro(usuario.mensagem);
            return;
        }

        formularioUsuarioRef.current.salvarSucesso();
		
		setValorContexto(prevState =>({...prevState, idUsuarioAtual: usuario.id}));

		setValorContexto(prevState =>({...prevState, nomeUsuarioAtual: dados.nome_completo}));

		navegacao.replace(TELA_PRINCIPAL)
    }
   
   
    return (
		<ViewDegradeVertical titulo="Novo Usuário" voltar={()=>voltar()} ocultarPontos={true}>  	
            <Bloco todaArea={true}>          
				<FormularioUsuario ref={formularioUsuarioRef} salvar={salvar} novo={true}/>
			</Bloco>   
        </ViewDegradeVertical>)
}